import { ICategoryType } from '@introspection/index';
import { Form, FormGroup } from '@rxdi/forms';
import { Component, html, LitElement, property } from '@rxdi/lit-html';
import { StudioModalFormStyles } from '@shared/styles/modal.styles';

import { InputErrorTemplate } from './input-error.template';

/** Modal body: pick a category (used when creating a post). */
@Component({
  selector: 'category-forms',
  styles: [StudioModalFormStyles],
  template(this: CategoryFormComponent) {
    return html`
      <form
        name="category-form"
        @submit=${async () => {
          const validity = await this.form.updateValueAndValidity();

          if (!validity?.length) {
            this.dispatchEvent(
              new CustomEvent<Pick<ICategoryType, 'id'>>('submitted', {
                detail: {
                  id: this.form.value.categoryId,
                },
              })
            );
          }
        }}
      >
        <header>
          <span class="kicker">Journal</span>
          <h2>Choose a category</h2>
          <p>The article is created as a draft in this category; you can change it later in the editor.</p>
        </header>
        <div class="body">
          <label>
            Category
            <select name="categoryId" required>
              <option value="" disabled ?selected=${!this.model?.id}>Choose a category…</option>
              ${this.categories.map(
                (category) =>
                  html`<option value=${category.id} ?selected=${this.model?.id === category.id}>
                    ${category.name}
                  </option>`
              )}
            </select>
            ${InputErrorTemplate(this.form.get('categoryId') as never)}
          </label>
        </div>
        <footer>
          <button type="button" class="ghost" @click=${() => this.dispatchEvent(new CustomEvent('cancelled'))}>
            Cancel
          </button>
          <button type="submit" class="primary">Continue</button>
        </footer>
      </form>
    `;
  },
})
export class CategoryFormComponent extends LitElement {
  @property({ type: Object })
  model: ICategoryType;

  @property({ type: Array })
  categories: ICategoryType[];

  @Form({
    name: 'category-form',
    strategy: 'change',
    strict: true,
    // @rxdi/forms 0.7.243 reads options.customElements without a default
    customElements: [],
  })
  form = new FormGroup({
    categoryId: '',
  });

  OnUpdateFirst() {
    const model = this.model || {};
    Object.keys(model).map((key: never) => {
      if (this.form.get(key) && model[key]) {
        this.form.setValue(key, model[key]);
      }
    });
  }
}
